import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { px2dpSmall } from '../../../../utils/px2dp.js';

const vCardWidth = typeof window !== 'undefined' && (window.innerWidth - px2dpSmall(12) * 2 - px2dpSmall(9)) / 2;

function getCardComponentForName(name) {
  switch (name) {
    case 'goods_common_vert_style_8': return { registeredWidgetObj: require('./widgets/SHGoodsCommonVertFlatStyle8Widget.js').default, layoutType: 2 }      // 新品频道新增A8卡片样式扁平卡
    case 'note_common_vert_style_3': return { registeredWidgetObj: require('./widgets/SHNoteCommonVertFlatStyle3Widget.js').default, layoutType: 2 }  // 笔记流扁平卡卡片
    case 'goods_common_vert_flat_style_8': return { registeredWidgetObj: require('./widgets/SHGoodsCommonVertFlatStyle8Widget.js').default, layoutType: 2 }      // 新品频道新增A8卡片样式扁平卡
    case 'note_common_vert_flat_style_3': return { registeredWidgetObj: require('./widgets/SHNoteCommonVertFlatStyle3Widget.js').default, layoutType: 2 }  // 笔记流扁平卡卡片
    case 'note_common_vert_style_4': return { registeredWidgetObj: require('./widgets/SHNoteCommonVertStyle4Widget.js').default, layoutType: 2 }  // 笔记流扁平卡卡片
    default:
      return {}
  }
}

const getCardHeight = (data, widgetWidth = vCardWidth) => {
  const { component = '' } = data

  // 通用获取卡片高度方式
  const registeredWidgetObj = getCardComponentForName(component).registeredWidgetObj
  if (registeredWidgetObj && registeredWidgetObj.getWidgetHeight) {
    return registeredWidgetObj.getWidgetHeight(data, widgetWidth)
  }
  console.log("getCardHeight 不支持的组件名: ", component)
  return 0
}

const getTags = (dataSource) => {
  const { component = '' } = dataSource
  // 获取标签数据
  const registeredWidgetObj = getCardComponentForName(component).registeredWidgetObj
  if (registeredWidgetObj && registeredWidgetObj.getTags) {
    return registeredWidgetObj.getTags(dataSource)
  }
  return {}
}

/// 获取卡片是一行一还是一行二    1: 一行一  2: 一行二
const getVertHoriStatus = (dataSource) => {
  const { component = '' } = dataSource
  // 获取标签数据
  const layoutType = getCardComponentForName(component);
  return layoutType ? layoutType : 0
}

// 该卡片是否显示多配色
export const isCardShowStyleList = (data) => {
  const { component = '' } = data

  // 通用获取卡片高度方式
  const registeredWidgetObj = getCardComponentForName(component).registeredWidgetObj
  if (registeredWidgetObj && registeredWidgetObj.showStyleList !== 'undefined') {
    return registeredWidgetObj.showStyleList
  }
  return false
}

export {
  getCardHeight,
  getTags,
  getVertHoriStatus
}

export class SHCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { type, icon, onPress, getItemRef } = this.props;
    let view = null;

    const registeredWidgetObj = getCardComponentForName(type).registeredWidgetObj

    if (registeredWidgetObj && registeredWidgetObj.widget) {
      const Widget = registeredWidgetObj.widget
      view = <Widget
        ref={ref => getItemRef && getItemRef(ref)}
        {...this.props}
      />
      return view
    }
    return null;
  }
}

SHCard.propTypes = {
  type: PropTypes.string, //卡片类型
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.number]), //标题前的Icon
  onPress: PropTypes.func, //卡片点击事件
  onLongPress: PropTypes.func, //卡片长按
  onlayout: PropTypes.func, //卡片layout
  containRef: PropTypes.func, //卡片ref
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.number]), //主图片
  imageDesc: PropTypes.string, //主图片上右下角的描述
  title: PropTypes.string, //标题
  subTitle: PropTypes.string, //副标题
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), //价格
  couponTxt: PropTypes.string, //优惠信息
  discountTxt: PropTypes.string, //折扣信息
  desc: PropTypes.string, //右下角其他描述信息
  goodsImgFadeDuration: PropTypes.number, // 图片展示是否需要渐变默认需要-1 不需要0
};
SHCard.defaultProps = {
  type: 'goods_common_vert_flat_style_8',
  icon: null,
  onPress: () => { },
  onlayout: () => { },
  onLongPress: () => { },
  containRef: () => { },
  image: null,
  imageDesc: '',
  title: '',
  subTitle: '',
  price: '',
  couponTxt: '',
  discountTxt: '',
  desc: '',
  goodsImgFadeDuration: -1,
};



// WEBPACK FOOTER //
// ./components/pipeline-recommend/lib/SHCard/SHCard.jsx